import styled from 'styled-components';
import { getSpacing, lineHeight, typography } from 'stylesheet';
var StyledUnstyled = styled.div.withConfig({
  displayName: "MetaRenderBlockstyle__StyledUnstyled",
  componentId: "sc-1gmmler-0"
})(["", ""], typography.main);
var StyledH2 = styled.h2.withConfig({
  displayName: "MetaRenderBlockstyle__StyledH2",
  componentId: "sc-1gmmler-1"
})(["", ""], typography.h2);
var StyledH3 = styled.h3.withConfig({
  displayName: "MetaRenderBlockstyle__StyledH3",
  componentId: "sc-1gmmler-2"
})(["", ""], typography.h3);
var StyledBlockQuote = styled.blockquote.withConfig({
  displayName: "MetaRenderBlockstyle__StyledBlockQuote",
  componentId: "sc-1gmmler-3"
})(["font-style:italic;text-align:center;"]);
var WysiwygCommon = styled.div.withConfig({
  displayName: "MetaRenderBlockstyle__WysiwygCommon",
  componentId: "sc-1gmmler-4"
})(["margin-top:", ";line-height:", ";"], getSpacing(2), lineHeight.large);
var WysiwygCommon2 = styled.div.withConfig({
  displayName: "MetaRenderBlockstyle__WysiwygCommon2",
  componentId: "sc-1gmmler-5"
})(["padding-top:", ";"], getSpacing(2));
export { StyledUnstyled, StyledH2, StyledH3, StyledBlockQuote, WysiwygCommon, WysiwygCommon2 };